const states = [
  '...',
  'Aguascalientes',
  'Baja California',
  'Baja California Sur',
  'Chihuahua',
  'Chiapas',
  'Campeche',
  'Ciudad De México',
  'Coahuila',
  'Colima',
  'Durango',
  'Guerrero',
  'Guanajuato',
  'Hidalgo',
  'Jalisco',
  'Michoacan',
  'Estado De México',
  'Morelos',
  'Nayarit',
  'Nuevo León',
  'Oaxaca',
  'Puebla',
  'Quintana Roo',
  'Queretaro',
  'Sinaloa',
  'San Luis Potosí',
  'Sonora',
  'Tabasco',
  'Tlaxcala',
  'Tamaulipas',
  'Veracruz',
  'Yucatán',
  'Zacatecas'
];

export default states;
